<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    /* this.$alert(
      '尊敬的用户：协会现对网站进行升级维护工作，时间约一周，即日起网站暂时关闭，如需获取协会信息可关注“广东省政府采购协会”微信公众号。维护期间如给您带来不便，敬请谅解！',
      {
        confirmButtonText: '确定'
      }
    ); */
  }
};
</script>
<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  filter: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=rgba(184,196,203,.5),endColorStr=rgba(255,255,255,.5));
  background: -ms-linear-gradient(top, rgba(184, 196, 203, 0.5), rgba(255, 255, 255, 0.5));
  background: -moz-linear-gradient(top, rgba(184, 196, 203, 0.5), #f6f6f8);
  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(rgba(184, 196, 203, 0.5)), to(#f6f6f8));
  background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(rgba(184, 196, 203, 0.5)), to(rgba(255, 255, 255, 0.5)));
  background: -o-linear-gradient(top, rgba(184, 196, 203, 0.5), rgba(255, 255, 255, 0.5));
  background: -webkit-linear-gradient(top, rgba(184, 196, 203, 0.5), rgba(255, 255, 255, 0.5));
}
</style>
